// extracted by mini-css-extract-plugin
export default {"wrapper":"OrbSpotText_wrapper__DE2UI","item":"OrbSpotText_item__HzZid","wider":"OrbSpotText_wider__FJC-P"};